import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    drawer: false,
    profile: {
    },
    setting: {
      COLOR: "#1791DC",
      BACKGROUNDCOLOR:  "#4CAF50",
    },
  },
  getters: {
  },
  mutations: {
    updateDrawer(state) {
      state.drawer = !state.drawer;
    },
  },
  actions: {
  },
  modules: {
  }
})
